import { type SavedConfigurationDTO } from "~/features/configurator/Linear/dtos";
import { transformSavedConfig } from "~/features/configurator/Linear/savedConfigTransformer";
import { SavedConfigurationsView } from "~/features/savedConfigurations/SavedConfigurationsView";

// Re-export types for backwards compatibility
export {
  SavedConfigContext,
  type SavedConfigurationItem,
} from "~/features/savedConfigurations/SavedConfigurationsView";

/**
 * Page entry point for Saved Configurations.
 * This is a thin wrapper that delegates to the feature component.
 */
export function createSavedConfigurationsPage(data: string) {
  const parsedData = JSON.parse(data) as SavedConfigurationDTO[];
  const items = transformSavedConfig(parsedData);

  return <SavedConfigurationsView initialItems={items} />;
}
